// extracted by mini-css-extract-plugin
export default {"table":"BlockedUserErrorDialog_table_dwyYe","list":"BlockedUserErrorDialog_list_FgSM3"};